import React, { Component } from "react";
import { connect } from "react-redux";
import { cekCookies } from "../../../../../actions";
import __ from "lodash";
import { Row, Col, Alert, Card } from "react-bootstrap";
import Loader from "../../../../Loader";
import LoaderModal from "../../../../modal/LoaderModal";
import Navbar from "../../../navbar/Navbar";
import Sidebar from "../../../sidebar/Sidebar";
import { CONFIG } from "../../../../../config";
import accountManagement from "../../../../../apis/accountManagement";

import KelasSearch from "../../../../../entity/KelasSearch";
import DropdownTahunAjaran from "../../masterDropDown/DropdownTahunAjaran";
import DropdownKelas from "../../masterDropDown/DropdownKelas";

import ReportPeminatan from "../../../../../pages/Reports/Peminatan/ReportPeminatan";
import KecakapanUmum from "./KecakapanUmum";
import DetailKu from "./DetailKu";
import jsonFile from "./report-peminatan.json";

class Peminatan extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReport: false,
            isReportSiswa: false,
            isReportDetailKu: false,
            kodeJenjangSekolah: null,
            ta: [],
            kelas: [],
            jadwalCbt: [],
            tahunAjaran: null,
            idKelas: null,
            idJadwalCbt: null,
            jurusan: {},
            kuota: {},
            jumlahSiswa: null,
            responseReport: [],
        };
    }

    async componentDidMount() {
        this.setState({ isFetching: true });
        await this.props.cekCookies();
        if (!__.isEmpty(this.props.account)) {
            this.jenjangSekolah();
            this.fetchTa();
            this.fetchKelas();
        }
        this.setState({ isFetching: false });
        //  console.log('res submit == ', jsonFile)
        //  this.setState({
        //      resMessage: null,
        //      isFetching: false,
        //      responseReport: jsonFile,
        //      isReport: true,
        //  });
    }

    fetchTa = async () => {
        //fetch tahun ajaran dulu
        const resTa = await accountManagement
            .get(CONFIG.ACCOUNT_MANAGEMENT_LIST_TAHUN_AJARAN)
            .catch(function (error) { });
        if (resTa) {
            if (
                resTa.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE
            ) {
                this.setState({
                    ta: resTa.data.data,
                });
            }
        }

        resTa.data.data.map((val) => {
            if (val.status == "1") {
                this.setState({ kodeTa: val.kodeTahunAjaran });
                this.setState((prevState) => {
                    let kuota = Object.assign({}, prevState.kuota);
                    kuota["tahunAjaran"] = val.kodeTahunAjaran;
                    return { kuota };
                });
            }
        });
    };

    fetchKelas = async () => {
        this.setState({ isFetching: true });
        //fetch sekolah dulu
        const resSekolah = await accountManagement
            .get(
                CONFIG.ACCOUNT_MANAGEMENT_GET_SEKOLAH +
                this.props.account.idSekolah
            )
            .catch(function (error) { });
        let kodeJenjang = null;
        if (resSekolah) {
            if (
                resSekolah.data.errorSchema.errorCode ===
                CONFIG.SUCCESS_ERROR_CODE
            ) {
                kodeJenjang = resSekolah.data.data.kodeJenjangSekolah;
            }
        }

        //fetch kelas setelah dapat data sekolah
        const response = await accountManagement
            .post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS, {
                KelasSearch,
                ["kodeJenjangSekolah"]: kodeJenjang,
            })
            .catch(function (error) { });
        // masukan data kelas ke dropdown
        if (response) {
            if (
                response.data.errorSchema.errorCode ===
                CONFIG.SUCCESS_ERROR_CODE
            ) {
                this.setState({
                    kelas: response.data.data,
                });
            }
        }
        this.setState({ isFetching: false });
    };

    async jenjangSekolah() {
        const response = await accountManagement
            .get(CONFIG.PEMINATAN_)
            .catch(function (error) { });

        if (response) {
            if (
                response.data.errorSchema.errorCode ===
                CONFIG.SUCCESS_ERROR_CODE
            ) {
                this.setState({
                    jurusan: response.data.data.jurusan,
                    kodeJenjangSekolah: response.data.data.kodeJenjangSekolah,
                    isFetching: false,
                });
            }

            this.setState((prevState) => {
                let kuota = Object.assign({}, prevState.kuota);
                kuota["kodeJenjangSekolah"] =
                    response.data.data.kodeJenjangSekolah;
                return { kuota };
            });
        }
    }

    hancleChange = async (e) => {
        let key = e.target.name;
        let val = e.target.value;

        this.setState((prevState) => {
            let kuota = Object.assign({}, prevState.kuota);
            kuota[key] = parseInt(val);
            return { kuota };
        });
    };

    handleOnChangeInput = async (e) => {
        let name = e.target.name;
        let val = e.target.value;

        this.setState((prevState) => {
            let kuota = Object.assign({}, prevState.kuota);
            kuota[name] = val;
            return { kuota };
        });

        // cari profil PEMINATAN
        if (name === "idKelas") {
            this.setState({
                isFetching: true,
                jadwalCbt: [],
                jumlahSiswa: null,
                idKelas: val,
            });
            const response = await accountManagement
                .get(CONFIG.REPORT_CBT_GET_JADWAL, {
                    params: {
                        tahunAjaran: this.state.kodeTa,
                        idSekolah: this.props.account.idSekolah,
                        idKelas: val,
                        tipeCbt: "PEMINATAN",
                    },
                })
                .catch(function (error) {
                    console.log(error);
                });

            if (response) {
                if (
                    response.data.errorSchema.errorCode ===
                    CONFIG.SUCCESS_ERROR_CODE
                ) {
                    this.setState({
                        jadwalCbt: response.data.data,
                    });
                }
            }

            const fetchJumlahSiswaKelas = await accountManagement
                .post(CONFIG.PEMINATAN_JUMLAH_SISWA_KELAS, {
                    tahunAjaran: this.state.kodeTa,
                    idKelas: val,
                })
                .catch(function (error) {
                    console.error(error);
                });

            if (
                fetchJumlahSiswaKelas.data.errorSchema.errorCode ===
                CONFIG.SUCCESS_ERROR_CODE
            ) {
                console.log("SUKSES");
                this.setState({
                    jumlahSiswa: fetchJumlahSiswaKelas.data.data.jumlahSiswa,
                });
            }

            this.setState({ isFetching: false });
        } else if (name === "tahunAjaran") {
            this.setState({ kodeTa: val, idKelas: "" });
        }
    };

    handleSubmit = async (e) => {
        this.setState({ isFetching: true });
        e.preventDefault();
        console.log(this.state);
        const { kuota } = this.state;

        const respSubmit = await accountManagement
            .post(CONFIG.PEMINATAN_REPORTING, kuota)
            .catch(function (error) {
                console.error(error);
            });

        if (
            respSubmit.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE
        ) {
            console.log("SUKSES");
            this.setState({
                resMessage: null,
                isFetching: false,
                responseReport: respSubmit,
                isReport: true,
            });
        } else {
            console.log("GAGAL");
            this.setState({
                resMessage: respSubmit.data.errorSchema.errorMessage,
                isFetching: false,
                alertShow: true,
                isReport: false,
            });
        }
    };

    tutupReport = async () => {
        this.setState({
            isReport: false,
            isReportSiswa: false,
            isReportDetailKu: false,
            alertShow: false,
        });
    };

    componentDidUpdate() {
        console.clear();
        console.log(this.state);
    }

    render() {
        const {
            jurusan,
            kodeJenjangSekolah,
            isReport,
            isReportSiswa,
            isReportDetailKu,
            jadwalCbt,
            jumlahSiswa,
        } = this.state;
        return (
            <>
                {!isReport && !isReportSiswa && !isReportDetailKu ? (
                    <div className="wrapper">
                        <LoaderModal isFetching={this.state.isFetching} />
                        <Sidebar account={this.props.account} />
                        <div id="content" style={{ paddingBottom: "50px" }}>
                            <Navbar title="Peminatan" />
                            {this.loadAlert()}
                            {kodeJenjangSekolah === "SMA" ||
                                kodeJenjangSekolah === "MA" ? (
                                <>
                                    <form onSubmit={this.handleSubmit}>
                                        <Row>
                                            {/* DETAIL PROFIL JADWAL */}
                                            <Col>
                                                <b>Pilih Jadwal</b>
                                                <Col
                                                    style={{
                                                        marginTop: "10px",
                                                    }}
                                                >
                                                    <select
                                                        className="form-control"
                                                        name="tahunAjaran"
                                                        value={
                                                            this.state.tahunAjaran
                                                        }
                                                        onChange={
                                                            this
                                                                .handleOnChangeInput
                                                        }
                                                        required
                                                    >
                                                        <option
                                                            value=""
                                                            selected
                                                            disabled
                                                        >
                                                            ~~ Pilih Tahun
                                                            Ajaran ~~
                                                        </option>
                                                        <DropdownTahunAjaran
                                                            tahunAjaran={
                                                                this.state.ta
                                                            }
                                                        />
                                                    </select>
                                                </Col>
                                                <Col
                                                    style={{
                                                        marginTop: "10px",
                                                    }}
                                                >
                                                    <select
                                                        className="form-control"
                                                        name="idKelas"
                                                        value={
                                                            this.state.idKelas
                                                        }
                                                        onChange={
                                                            this
                                                                .handleOnChangeInput
                                                        }
                                                        required
                                                    >
                                                        <option
                                                            value=""
                                                            selected
                                                            disabled
                                                        >
                                                            ~~ Pilih Kelas ~~
                                                        </option>
                                                        <DropdownKelas
                                                            kelas={
                                                                this.state.kelas
                                                            }
                                                        />
                                                    </select>
                                                </Col>
                                                <Col
                                                    style={{
                                                        marginTop: "10px",
                                                    }}
                                                >
                                                    <select
                                                        className="form-control"
                                                        name="idJadwal"
                                                        value={
                                                            this.state.idJadwal
                                                        }
                                                        onChange={
                                                            this
                                                                .handleOnChangeInput
                                                        }
                                                        required
                                                    >
                                                        <option
                                                            value=""
                                                            selected
                                                            disabled
                                                        >
                                                            ~~ Pilih CBT ~~
                                                        </option>
                                                        {jadwalCbt.map(
                                                            (jadwal) => (
                                                                <option
                                                                    value={
                                                                        jadwal.idJadwalCbt
                                                                    }
                                                                >
                                                                    {
                                                                        jadwal.namaJadwalCbt
                                                                    }
                                                                </option>
                                                            )
                                                        )}
                                                    </select>
                                                </Col>
                                            </Col>
                                            {/* DETAIL KUOTA */}
                                            <Col>
                                                <b>
                                                    Input Kuota Jurusan{" "}
                                                    {kodeJenjangSekolah}&nbsp;{" "}
                                                    {jumlahSiswa != null && (
                                                        <>
                                                            ({jumlahSiswa}{" "}
                                                            Siswa)
                                                        </>
                                                    )}
                                                </b>
                                                <Col>
                                                    <Col
                                                        style={{
                                                            marginTop: "10px",
                                                        }}
                                                    >
                                                        {/* <div className="form-group"> */}
                                                        {/* <label>IPA</label> */}
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            placeholder="Kuota IPA"
                                                            name="ipa"
                                                            onChange={
                                                                this
                                                                    .hancleChange
                                                            }
                                                            required
                                                            autoComplete="off"
                                                            min="0"
                                                        />
                                                        {/* </div> */}
                                                    </Col>
                                                    <Col
                                                        style={{
                                                            marginTop: "10px",
                                                        }}
                                                    >
                                                        {/* <div className="form-group"> */}
                                                        {/* <label>IPS</label> */}
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            placeholder="Kuota IPS"
                                                            name="ips"
                                                            onChange={
                                                                this
                                                                    .hancleChange
                                                            }
                                                            required
                                                            autoComplete="off"
                                                            min="0"
                                                        />
                                                        {/* </div> */}
                                                    </Col>
                                                    <Col
                                                        style={{
                                                            marginTop: "10px",
                                                        }}
                                                    >
                                                        {/* <div className="form-group"> */}
                                                        {/* <label>BAHASA</label> */}
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            placeholder="Kuota BAHASA"
                                                            name="bahasa"
                                                            onChange={
                                                                this
                                                                    .hancleChange
                                                            }
                                                            required
                                                            autoComplete="off"
                                                            min="0"
                                                        />
                                                        {/* </div> */}
                                                    </Col>
                                                    {kodeJenjangSekolah ===
                                                        "MA" && (
                                                            <Col
                                                                style={{
                                                                    marginTop:
                                                                        "10px",
                                                                }}
                                                            >
                                                                {/* <div className="form-group"> */}
                                                                {/* <label>AGAMA</label> */}
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    placeholder="Kuota AGAMA"
                                                                    name="agama"
                                                                    onChange={
                                                                        this
                                                                            .hancleChange
                                                                    }
                                                                    required
                                                                    autoComplete="off"
                                                                    min="0"
                                                                />
                                                                {/* </div> */}
                                                            </Col>
                                                        )}
                                                </Col>
                                            </Col>
                                        </Row>

                                        <br />
                                        <Row>
                                            <Col>
                                                <button
                                                    type="submit"
                                                    value="Submit"
                                                    className="btn btn-outline-primary"
                                                >
                                                    Report Peminatan
                                                </button>
                                                &nbsp;
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-primary"
                                                    onClick={() =>
                                                        this.setState({
                                                            isReportSiswa: true,
                                                        })
                                                    }
                                                >
                                                    Report KU
                                                </button>
                                                &nbsp;
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-primary"
                                                    onClick={() =>
                                                        this.setState({
                                                            isReportDetailKu: true,
                                                        })
                                                    }
                                                >
                                                    Detail KU
                                                </button>
                                            </Col>
                                        </Row>
                                    </form>
                                </>
                            ) : (
                                ""
                            )}
                        </div>
                    </div>
                ) : (
                    <>
                        {isReport && (
                            <ReportPeminatan
                                tutupReport={this.tutupReport}
                                response={this.state.responseReport}
                            />
                        )}
                    </>
                )}
                {isReportSiswa && (
                    <KecakapanUmum
                        tutupReport={this.tutupReport}
                        data={this.state}
                    />
                )}
                {isReportDetailKu && (
                    <DetailKu
                        tutupReport={this.tutupReport}
                        data={this.state}
                    />
                )}
            </>
        );
    }

    loading = () => {
        if (this.state.isLoading) {
            return <Loader />;
        }
    };

    loadAlert = () => {
        const { alertShow } = this.state;

        if (alertShow) {
            return (
                <Alert
                    variant="info"
                    onClose={() => this.setState({ alertShow: false })}
                    dismissible
                >
                    <strong>{this.state.resMessage}</strong>
                </Alert>
            );
        }
    };
}

const mapStateToProps = (state) => {
    return {
        account: state.account,
    };
};

export default connect(mapStateToProps, { cekCookies })(Peminatan);
